// Needs Bff implementation
export default async () => {
  // try {
  //   return {};
  // } catch (e) {
  //   logger.get('API').error('streams.startStream', e);
  //   return null;
  // }
  return;
};
